export default __webpack_public_path__ + "static/media/uriel-soberanes.54e40461.jpg";